import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Segmented pill toggle between Today (/) and Trip (/trip).
 * Renders as <Link>s so each side is a real navigation, while
 * the active side visually fills the pill like a tab.
 */
const ModeToggle = () => {
  const location = useLocation();
  const isTrip = location.pathname.startsWith('/trip');

  const baseClasses =
    'inline-flex items-center justify-center px-5 py-2 text-sm rounded-full transition-[background-color,color,opacity] duration-200 ease-[cubic-bezier(0.23,1,0.32,1)]';
  const activeClasses = 'bg-background/60 dark:bg-background/40 text-gray-900 dark:text-gray-50 font-medium shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]';
  const inactiveClasses = 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100';

  return (
    <div
      role="tablist"
      aria-label="Mode"
      className="inline-flex items-center gap-1 p-1 rounded-full border border-foreground/20 bg-background/20 backdrop-blur-md mb-4"
    >
      <Link
        to="/"
        role="tab"
        aria-selected={!isTrip}
        className={`${baseClasses} ${!isTrip ? activeClasses : inactiveClasses}`}
      >
        Today
      </Link>
      <Link
        to="/trip"
        role="tab"
        aria-selected={isTrip}
        className={`${baseClasses} ${isTrip ? activeClasses : inactiveClasses}`}
      >
        Trip
      </Link>
    </div>
  );
};

export default ModeToggle;
